<template>
  <div
    class="fixed left-0 top-0 z-[55] pointer-events-none isolate"
    :class="viewportRotationClasses"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { usePlayerViewportRotationClasses } from '@/composables/usePlayerViewportRotationClasses'

const { viewportRotationClasses } = usePlayerViewportRotationClasses()
</script>
